<template>
  <div class="content">
    <!-- 图文详情(付费) -->
    <div class="text-detail">
      <!-- 图文内容 -->
      <div class="text-content">
        <div
          :class="[this.isPay == 1 ? 'hiddCon' : '', 'conBox']"
          v-html="article.content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTextDetailList } from '@/api/textDetail';
export default {
  name: 'payText',
  data() {
    return {
      article: {},
      isPay: '', //是否免费(0免费，1付费)
    };
  },
  methods: {
    // 获取图文详情
    async getTextDetail() {
      let res = await getTextDetailList({ id: this.$route.query.id });
      if (res) {
        let data = res.data.rst.extData;
        this.article = data;
      }
    },
  },
  created() {
    this.isPay = this.$route.query.isPay;
    console.log(this.isPay);
    this.getTextDetail();
  },
  mounted() {},
  updated() {
    let DomList = document
      .getElementsByClassName('conBox')[0]
      .querySelectorAll('p');
    for (let i in DomList) {
      if (DomList[i].style) {
        DomList[i].style.fontSize = '16px';
      }
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  padding-left: 14px;
  padding-right: 14px;
}
.text-detail {
  background-color: #fff;
  .article-title {
    padding: 0 0 14px 0;
    font-size: 20px;
    color: #222222;
    line-height: 30px;
  }
  .author-info {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
  .text-content {
    padding-top: 14px;
    .abstract {
      padding: 20px 16px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-bottom: 20px;
    }
    .art-content {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 25px;
    }
    .pay-all {
      width: 236px;
      // height: 38px;
      background: #fa964b;
      border-radius: 8px;
      line-height: 38px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      a {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .join-img {
    width: 100%;
    overflow: hidden;
  }
  .img-content {
    margin: 20px 0;
    height: 193px;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #222222;
    line-height: 22px;
  }
  .about-read {
    margin: 20px 0;
  }
}
.hiddCon {
  height: 600px;
  overflow: hidden;
}
</style>
